import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../axiosInstance/axiosInstance";
import { ProjectResponse } from "./ProjectResponse";
import { Project } from "./Project";
import { ProjectResponseMapper } from "./ProjectResponseMapper";
import { Milestone } from "./Milestone";
import { MilestoneResponse } from "./MilestoneResponse";

export const fetchProjectsAsync = createAsyncThunk(
  "projects/fetchProjects",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/projects`);
      const data: ProjectResponse[] = response.data;
      const projectResponseMapper = new ProjectResponseMapper();
      const mappedResponse: Project[] = data.map((project) =>
        projectResponseMapper.mapProjectResponseToProject(project)
      );
      return mappedResponse;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchMilestoneByIdAsync = createAsyncThunk(
  "projects/fetchMilestoneById",
  async (milestoneId: number, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get<MilestoneResponse>(
        `/milestones/${milestoneId}`
      );
      const projectResponseMapper = new ProjectResponseMapper();
      const mappedResponse: Milestone =
        projectResponseMapper.mapMilestoneResponseToMilestone(response.data);
      return mappedResponse;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
